import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';

export default class DestinationSettingsIndexRoute extends Route {
  @service declare access: Services['access'];
  @service declare router: Services['router'];

  redirect(): void {
    if (this.access.hasPersonalSettingsTab) {
      this.router.transitionTo('destination.settings.personal');
    } else if (
      this.access.hasFeature('settings.compset.app.view') ||
      this.access.hasFeature('settings.compset.rms.view')
    ) {
      this.router.transitionTo('destination.settings.competitors');
    } else if (this.access.hasFeature('settings.hotel_access.edit')) {
      this.router.transitionTo('destination.settings.hotels');
    } else if (this.access.hasFeature('reports.view.settings')) {
      this.router.transitionTo('destination.settings.reports');
    } else if (this.access.hasFeature('spider.settings.edit')) {
      this.router.transitionTo('destination.settings.spider');
    }
  }
}
